export type OrderPrevious = {
  data: string;
  quantity: number;
};

export class Order {
  idRichiesta: number | null;
  idAgente: number | null;
  status: number | null;
  dateCreated: string | null;
  agente: string | null;
  address: string | null;
  extra: boolean | null;
  quantity: number | null;
  idCampione: number | null;
  sku: string | null;
  qta: string | null;
  campione: string | null;
  division: string | null;
  image: string | null;
  lot: string | null;
  price: number | null;
  trackingCode: string | null;
  previous: OrderPrevious[];
  statusText: string | null;

  // crea una model per l'order con i campi della tabella
  constructor(data: any = {}) {
    this.idRichiesta = data.idRichiesta != null ? Number(data.idRichiesta) : null;
    this.idAgente = data.idAgente != null ? Number(data.idAgente) : null;
    this.status = data.status ?? null;
    this.statusText = data.statusText ?? null;
    this.dateCreated = data.dateCreated ?? null;
    this.agente = data.agente ?? null;
    this.address = data.address ?? null;
    this.extra = data.extra != null ? parseInt(String(data.extra), 10) === 1 : null;
    this.quantity = data.quantity != null ? Number(data.quantity) : null;
    this.idCampione = data.idCampione != null ? Number(data.idCampione) : null;
    this.sku = data.sku ?? null;
    this.qta = data.qta != null ? data.qta : null;
    this.campione = data.campione ?? null;
    this.division = data.division ?? null;
    this.image = data.image ?? null;
    this.lot = data.lot ?? null;
    this.price = data.price != null ? Number(data.price) : null;
    this.trackingCode = data.trackingCode ?? null;
    this.previous = Array.isArray(data.previous)
      ? data.previous.map((p: any) => ({
          data: p.data ?? p.date ?? p.prevDateCreated ?? "",
          quantity: p.quantity != null ? Number(p.quantity) : 0,
        }))
      : [];
  }
}
export default Order;